import * as constants from "./actionTypes";

const initialState = {
  user: null,
  cartItems: [],
  sideBarVisibility: false,
};

const rootReducer = (appstate = initialState, action) => {
  switch (action.type) {
    case constants.SET_USER:
      return { ...appstate, user: action.payload };
    case constants.SET_CART_ITEMS:
      return { ...appstate, cartItems: action.payload };
    case constants.SET_SIDE_BAR_VISIBILITY:
      return { ...appstate, sideBarVisibility: action.payload };
    case constants.SET_MY_CART_MODAL_VISIBILITY:
      return { ...appstate, myCartModalVisibility: action.payload };
    default:
      return { ...appstate };
  }
};

export default rootReducer;
